import React from 'react';

import { Container, Typography } from '@mui/material';

import { CustomButton } from '../../components/UI/CustomButton';
import { H3 } from '../../components/UI/Texts';
import styled from '../../styled';
import {
  colorsPalette,
  MIDDLE_MARGIN_PX,
  MIDDLE_RADIUS_PX,
  SMALL_MARGIN_PX,
  SUBMIDDLE_MARGIN_PX,
} from '../../theme';

const StickyBlock = ({ title, subtitle, btnTitle, visible, handleClick }) => {
  return (
    <Wrapper visible={visible}>
      <StyledContainer>
        <TextWrapper>
          <Title variant="h3">{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </TextWrapper>
        <BtnWrapper>
          <CustomButton onClick={handleClick}>{btnTitle}</CustomButton>
        </BtnWrapper>
      </StyledContainer>
    </Wrapper>
  );
};

export default StickyBlock;

const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'visible',
})`
  width: 100vw;
  position: fixed;
  bottom: ${({ visible }) => (visible ? 0 : '-250px')};
  left: 0;
  padding: ${SMALL_MARGIN_PX} 0 ${SUBMIDDLE_MARGIN_PX} 0;
  border-radius: ${MIDDLE_RADIUS_PX} ${MIDDLE_RADIUS_PX} 0 0;
  background-color: ${colorsPalette.violetAnalyticsCard};
  z-index: 10;
  transition: 0.3s;
  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: ${SUBMIDDLE_MARGIN_PX} 0;
    border-radius: 0;
    box-shadow: 10px 5px 40px rgba(0, 0, 0, 0.4);
  }
`;

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

const TextWrapper = styled('div')`
  margin-bottom: ${SUBMIDDLE_MARGIN_PX};
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: 0;
    margin-right: ${MIDDLE_MARGIN_PX};
  }
`;

const Title = styled(H3)`
  margin-bottom: 4px;
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: 0;
  }
`;

const Subtitle = styled(Typography)`
  color: ${colorsPalette.gray};
  font-size: 14px;
  line-height: 1.2;
`;

const BtnWrapper = styled('div')`
  flex-shrink: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  & > button {
    width: 100%;
  }
  ${({ theme }) => theme.breakpoints.up('sm')} {
    & > button {
      width: unset;
    }
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: unset;
  }
`;
